import type { IPrepareData } from '@/types'

interface INearPrepareData {
  nonce: number
  blockHash: string
  fee: number
  registered: string
}

export class NearPrepareData implements IPrepareData {
  public nonce: number
  public blockHash: string
  public fee: number
  public registered: string

  constructor(data: INearPrepareData) {
    this.nonce = data.nonce
    this.blockHash = data.blockHash
    this.fee = data.fee
    this.registered = data.registered ?? 'completed'
  }
}
